import React from "react";

import { useDictionary } from "hooks";
import { CAYUSE_TYPES } from "globals/constants";

import Integration from "./Integration";


function HaploRepository (props) {
	const dictionary = useDictionary('haploRepositoryIntegration');

	return <Integration title={dictionary.headline ?? 'Link to Repository'} { ...props }/>;
}

HaploRepository.showInPalette = () => true;

HaploRepository.paletteInformation = () => ({
	id: "cayuseHaploRepository",
	name: "Repository Search",
	type: "cayuseHaploRepository",
	group: "sponsoredProject"
});

HaploRepository.newElement = () => ({
	designInfo: {
		stencilSuperIds: [
			"Component"
		],
		stencilId: "cayuse-haplo-repository",
		customStencilId: "null"
	},
	type: CAYUSE_TYPES.HAPLO_REPOSITORY,
	cayuseShortLabel: "Repository"
});

HaploRepository.initialValue = "{{haploRepository}}";


export default HaploRepository;
